import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { type ReactNode } from 'react';

import AffirmPromo, {
  getAffirmPrice,
} from '@/app/[locale]/store/_components/AffirmPromo';
import useShowPDPAffirmMessage from '@/app/[locale]/store/_hooks/useShowPDPAffirmMessage';
import type { ListProduct } from '@/queries/Products';

import type { BuildHardwareOrderBaseProps } from '../_types/order';
import { getPriceAndDiscount } from '../_utils/getPriceAndDiscount';
import AddOnModal from '../AddOnModal';

export interface OrderSummaryProps
  extends Pick<
    BuildHardwareOrderBaseProps,
    | 'order'
    | 'monthlyMembership'
    | 'twoYearWarranty'
    | 'threeYearWarranty'
    | 'yearlyMembership'
  > {
  readonly isAddingToCart: boolean;
  readonly isSelectingSize: boolean;
  readonly onAddToCart: () => Promise<void>;
  readonly onRadioChange: (value: string) => void;
  readonly product: ListProduct | undefined;
  readonly ringCount: number;
  readonly tag?: ReactNode;
}

const OrderSummary = ({
  isAddingToCart,
  isSelectingSize,
  onAddToCart,
  onRadioChange,
  order,
  product,
  tag,
  ...rest
}: OrderSummaryProps) => {
  const { discountPrice, price } = getPriceAndDiscount(product);
  const discountedProductPrice = product?.discountedPrice;

  const showAffirm = useShowPDPAffirmMessage(
    discountedProductPrice,
    product?.handle,
  );
  const affirmPrice = getAffirmPrice(discountPrice, price!);

  if (!product) {
    return null;
  }

  return (
    <div className="flex flex-col items-center lg:items-stretch">
      <div className="w-full max-w-sm rounded-xl bg-sandstone-300 p-6 max-lg:mb-4">
        {tag}
        <AddOnModal
          isAddingToCart={isAddingToCart}
          isSelectingSize={isSelectingSize}
          location="summary card"
          onAddToCart={onAddToCart}
          onRadioChange={onRadioChange}
          order={order}
          {...rest}
        />
        {showAffirm && (
          <Typography className="mt-4 text-xs" align="center" Element="div">
            <AffirmPromo
              className="text-sandstone-500"
              pageType="product"
              price={affirmPrice}
            />
          </Typography>
        )}
      </div>
    </div>
  );
};

export default OrderSummary;
